<template>
  <ValidationProvider :vid="set.code+''+field.code" rules="required" v-slot="{ errors }">
    <v-text-field
      outlined
      hide-details
      :label="template.name"
      :error-messages="errors"
      v-model="field.value"
      clearable
    ></v-text-field>
  </ValidationProvider>
</template>

<script>
export default {
  props: ['set', 'field', 'template'],
  name: 'Field',
};
</script>
